import { useState } from 'react';
import { renderMarkdown } from '../../utils/renderMarkdown';

function MarkdownEditor({ value, onChange, rows = 9 }) {
  const [tab, setTab] = useState('write');

  return (
    <div className="md-editor">
      <div className="md-tab-bar">
        <button type="button" className={`md-tab${tab === 'write'   ? ' active' : ''}`} onClick={() => setTab('write')}>Write</button>
        <button type="button" className={`md-tab${tab === 'preview' ? ' active' : ''}`} onClick={() => setTab('preview')}>Preview</button>
      </div>

      {tab === 'write' && (
        <textarea
          className="md-textarea"
          value={value}
          onChange={e => onChange(e.target.value)}
          rows={rows}
          placeholder="Write description in Markdown…"
        />
      )}

      {tab === 'preview' && (
        <div
          className="md-preview"
          dangerouslySetInnerHTML={{ __html: renderMarkdown(value) }}
        />
      )}
    </div>
  );
}

export default MarkdownEditor;
